import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'priceFormat',
  standalone: true
})
export class PriceFormatPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === '') {
      return '€ 0,00';
    }

    const numericValue = typeof value === 'string' ? 
      parseFloat(value.replace(',', '.')) : 
      value;

    if (isNaN(numericValue)) {
      return '€ 0,00';
    }

    try {
      return '€ ' + numericValue.toLocaleString('nl-NL', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      });
    } catch (e) {
      console.error('Error formatting price', e);
      return '€ ' + numericValue.toFixed(2).replace('.', ',');
    }
  }
}